import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {TabPanel} from "./TabPanelComponent";
import {ProductComponent} from "./ProductComponent";
import {BASE_URL_API, MARKET_BASE_URL_API} from "../Const";
import {BasketComponent} from "./BasketComponent";
import AliceCarousel from "react-alice-carousel";
import PositionedMenu from "./PositionedMenu";
import {BackButton, BottomMenu} from "./HookUtils";
import {Link} from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import SvgIcon from "@mui/material/SvgIcon";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import WhatsAppOutlinedIcon from "@mui/icons-material/WhatsApp";
import InstagramOutlinedIcon from "@mui/icons-material/Instagram";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import TableBarOutlinedIcon from "@mui/icons-material/TableBarOutlined";
import {Card, CardContent, Divider, Grid} from "@mui/material";

const BaleIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
               10-4.48 10-10S17.52 2 12 2zm4.8 7.2l-5.66 6.6
               a1 1 0 0 1-1.5.06l-2.44-2.44a1 1 0 1 1 1.41-1.41
               l1.68 1.68 4.92-5.74a1 1 0 1 1 1.52 1.25z"
        />
    </SvgIcon>
);

const RubikaIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12 2L3 7v10l9 5 9-5V7l-9-5zm0 2.2
               6.8 3.8L12 11.8 5.2 8 12 4.2zm-7
               5.5l6 3.3v6.7l-6-3.3V9.7zm8
               10.1v-6.7l6-3.3v6.7l-6 3.3z"
        />
    </SvgIcon>
);

export class ProductCollectionComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchedCategories: [],
            value: 0, // Default to 0, but will be updated if "All Products" is hidden
            marketInfo: {},
            open: false,
            popUpOpen: false,
            hasInitialCategories: false, // <-- NEW STATE to track if we should hide "All Products"
            showFullDescription: false
        };

        this.tabsRef = React.createRef();
        this.scrollerEl = null;
    }

    componentDidMount() {
        fetch(BASE_URL_API + "market/" + this.props.id + `?table_id=${this.props.tableId}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((results) => {
                if (results.code === 200) {
                    this.setState({
                        marketInfo: results.data,
                        tableInfo: results.table || null
                    });
                }
            })
            .catch((error) => console.log("market error", error));

        fetch(`${BASE_URL_API}subCategory?market_id=${this.props.id}&table_id=${this.props.tableId}`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                "Content-Type": "application/json",
            },
        })
            .then((response) => response.json())
            .then((results) => {
                const incoming = Array.isArray(this.props.initialCategories) && this.props.initialCategories.length > 0
                    ? this.props.initialCategories.map(String)
                    : (this.props.initialCategory ? [String(this.props.initialCategory)] : []);

                let finalCategories = results.data;
                let hasIncoming = incoming.length > 0;

                if (hasIncoming) {
                    const idSet = new Set(incoming);
                    finalCategories = results.data.filter((p) => idSet.has(String(p.id)));
                }

                this.setState({
                    fetchedCategories: finalCategories,
                    hasInitialCategories: hasIncoming, // Save this flag to state
                    // If we hide "All products" (index 0), default to the first fetched category (index 1)
                    // If no categories are fetched, fallback to 0 safely.
                    value: hasIncoming && finalCategories.length > 0 ? 1 : 0
                });
            })
            .catch((error) => console.log("subcategory error", error));

    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue});
    };

    render() {
        const {marketInfo, value, fetchedCategories, hasInitialCategories} = this.state;

        const renderMarketHeader = (marketInfo) => {
            const pics = Array.isArray(marketInfo?.pictures)
                ? marketInfo.pictures
                : [];
            const imgSrcs = pics.map((p) => MARKET_BASE_URL_API + p.url);

            return (
                <Paper
                    elevation={0}
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: 3,
                        mx: 1,
                        mb: 1.5,
                        mt: 15,
                        backgroundColor: "#fff",
                        boxShadow: "0 10px 26px rgba(0,0,0,0.08)",
                    }}
                >
                    {/* === Banner / Carousel === */}
                    <Box sx={{position: "relative"}}>
                        <AliceCarousel
                            autoPlay
                            infinite
                            mouseTracking
                            disableDotsControls={true}
                            disableButtonsControls={true}
                            animationDuration={700}
                            autoPlayInterval={2800}
                            renderPrevButton={({isDisabled}) => (
                                <IconButton
                                    disabled={isDisabled}
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: 12,
                                        transform: "translateY(-50%)",
                                        bgcolor: "rgba(255,255,255,0.9)",
                                        "&:hover": {bgcolor: "#fff"},
                                        boxShadow:
                                            "0 6px 16px rgba(0,0,0,0.15)",
                                        width: 36,
                                        height: 36,
                                        zIndex: 4,
                                    }}
                                >
                                    <ArrowBackIosNewRoundedIcon
                                        sx={{fontSize: 18}}
                                    />
                                </IconButton>
                            )}
                            renderNextButton={({isDisabled}) => (
                                <IconButton
                                    disabled={isDisabled}
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        right: 12,
                                        transform: "translateY(-50%)",
                                        bgcolor: "rgba(255,255,255,0.9)",
                                        "&:hover": {bgcolor: "#fff"},
                                        boxShadow:
                                            "0 6px 16px rgba(0,0,0,0.15)",
                                        width: 36,
                                        height: 36,
                                        zIndex: 4,
                                    }}
                                >
                                    <ArrowForwardIosRoundedIcon
                                        sx={{fontSize: 18}}
                                    />
                                </IconButton>
                            )}
                            renderDotsItem={({isActive}) => (
                                <span
                                    style={{
                                        display: "inline-block",
                                        width: isActive ? 18 : 8,
                                        height: 8,
                                        borderRadius: 999,
                                        marginInline: 4,
                                        background: isActive
                                            ? "#9a1111"
                                            : "rgba(255,255,255,0.6)",
                                        boxShadow: isActive
                                            ? "0 2px 8px rgba(154,17,17,0.4)"
                                            : "none",
                                        transition: "all .25s ease",
                                    }}
                                />
                            )}
                            items={(imgSrcs.length ? imgSrcs : [null]).map(
                                (src, idx) => (
                                    <Box
                                        key={idx}
                                        sx={{
                                            width: "100%",
                                            height: 220,
                                            background: src
                                                ? `url(${src}) center center / contain no-repeat`
                                                : "#f5f5f5",
                                            position: "relative",
                                        }}
                                    />
                                )
                            )}
                        />

                        {/* Shadow gradient */}
                        <Box
                            sx={{
                                position: "absolute",
                                inset: 0,
                                background:
                                    "linear-gradient(to top, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.1) 20%, rgba(0,0,0,0) 100%)",
                                zIndex: 1,
                            }}
                        />
                    </Box>

                    {/* === Market info overlay === */}
                    <Box
                        sx={{
                            position: "absolute",
                            insetInline: 0,
                            bottom: 0,
                            zIndex: 3,
                            px: 2,
                            pt: 6,
                            pb: 0,
                            color: "#fff",
                            direction: "rtl",
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 900,
                                fontFamily:
                                    "RokhFaNum, Arial, sans-serif",
                                textShadow:
                                    "0 2px 10px rgba(0,0,0,0.35)",
                                display: "flex",
                                alignItems: "baseline",
                                gap: 1,
                                mb: 0.5,
                            }}
                        >
                            {marketInfo?.name || "نام فروشگاه"}
                        </Typography>


                    </Box>
                </Paper>
            );
        };

        const renderMarketDescription = (marketInfo) => {
            if (!marketInfo || !marketInfo.content) return;

            return (<Card
                    sx={{
                        borderRadius: 3,
                        m: 1,
                        border: "1px solid rgba(255,255,255,0.08)",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
                        transition: "all 0.3s ease",
                    }}
                >
                    <CardContent sx={{pb: "12px !important"}}>
                        <Box
                            sx={{
                                position: "relative",
                                overflow: "hidden",

                                // smooth expand/collapse
                                transition: "max-height 0.35s ease",

                                maxHeight: this.state.showFullDescription
                                    ? 500 // big enough for full content
                                    : 48,  // ~2 lines height

                                pr: 1,
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: 15,
                                    lineHeight: 1.6,
                                    fontWeight: 'bold',
                                    // 👇 key trick
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: this.state.showFullDescription ? "unset" : 2,
                                    overflow: "hidden",
                                    whiteSpace: "pre-wrap",
                                }}
                            >
                                {marketInfo.content}
                            </Typography>
                        </Box>

                        {marketInfo.content.length > 80 && (
                            <Typography
                                onClick={() =>
                                    this.setState((prev) => ({
                                        showFullDescription: !prev.showFullDescription,
                                    }))
                                }
                                sx={{
                                    m: 1,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    cursor: "pointer",
                                    color: "#FF5252",
                                    display: "inline-block",
                                    borderBottom: "1px dashed rgba(255,255,255,0.6)",
                                }}
                            >
                                {this.state.showFullDescription ? "بستن" : "مشاهده بیشتر"}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            );
        };


        const shipping = marketInfo?.shipping
            ? Number(marketInfo.shipping).toLocaleString("fa-IR") +
            " تومان"
            : null;
        const categoryTitle = marketInfo?.category?.title;
        const insta =
            marketInfo?.instagram && marketInfo.instagram !== "none"
                ? String(marketInfo.instagram).replace(/^@/, "")
                : null;

        const bale =
            marketInfo?.bale && marketInfo.bale !== ""
                ? String(marketInfo.bale).replace(/^@/, "")
                : null;

        const rubika =
            marketInfo?.rubika && marketInfo.rubika !== ""
                ? String(marketInfo.rubika).replace(/^@/, "")
                : null;


        return (
            <div
                style={{
                    backgroundColor: "#ffffff",
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <AppBar
                    elevation={0}
                    sx={{
                        p: 0,
                        m: 0,
                        background: "rgba(238,238,238,0.3)",
                        backdropFilter: "blur(6px)",
                    }}
                >

                    <ToolbarMui
                        disableGutters
                        sx={{
                            p: 1,
                            minHeight: {xs: 48, sm: 56},
                            gap: 0.5,
                        }}
                    >

                        {(this.props.tableId == null || this.props.tableId === "") && (
                            <PositionedMenu
                                marketInfo={marketInfo}
                                iconSx={{fontSize: 22}}
                            />
                        )}

                        <Typography
                            variant="subtitle2"
                            component="div"
                            sx={{
                                mt: 1,
                                flex: "1 1 auto",
                                textAlign: "center",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                fontWeight: 900,
                                fontSize: "1rem",
                                letterSpacing: "0.3px",
                                color: "#fff",
                                background:
                                    "linear-gradient(90deg, #ff1744, #ff5252, #fff)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                animation:
                                    "shineMove 2s linear infinite",
                                "@keyframes shineMove": {
                                    "0%": {
                                        backgroundPosition: "0% 50%",
                                    },
                                    "100%": {
                                        backgroundPosition:
                                            "200% 50%",
                                    },
                                },
                                backgroundSize: "200% auto",
                            }}
                            title={marketInfo.name}
                        >
                            {marketInfo.name}
                            {this.state.tableInfo && (
                                <Typography variant="caption" sx={{m: 0}} display="block">
                                    {this.state.tableInfo.floor_name} - {this.state.tableInfo.table_name}
                                </Typography>
                            )}
                        </Typography>

                        <Box sx={{display: "flex", alignItems: "center"}}>
                            <IconButton
                                component={Link}
                                to={`/search?prefer_market_id=${
                                    marketInfo ? marketInfo.id : ""
                                }&table_id=${this.props.tableId}`}
                                aria-label="جستجو"
                            >
                                <SearchIcon/>
                            </IconButton>

                            <IconButton aria-label="سبد">
                                <BasketComponent compact table_id={this.props.tableId}/>
                            </IconButton>

                            {!this.props.tableId && <BackButton style={{marginRight: 4}}/>}

                        </Box>
                    </ToolbarMui>

                    {/* Tabs با Indicator سفارشی و بدون فاصله اول/آخر */}

                    <Tabs
                        ref={this.tabsRef}
                        value={value}
                        onChange={this.handleChange}
                        variant="scrollable"
                        scrollButtons={false} // Forces native touch swipe on mobile
                        textColor="inherit"
                        TabIndicatorProps={{
                            style: {display: "none"},
                        }}
                        sx={{
                            direction: "ltr",
                            "& .MuiTabs-flexContainer": {
                                flexWrap: "nowrap",
                                justifyContent: "flex-start",
                            },
                            "& .MuiTab-root": {
                                minWidth: "auto !important",
                                paddingLeft: "12px",
                                paddingRight: "12px",
                                margin: "0 !important",
                            },
                        }}
                    >
                        {/* Tab 0: همه محصولات (Conditionally Rendered) */}
                        {!hasInitialCategories && (
                            <Tab
                                value={0}
                                key="all"
                                label="همه محصولات"
                                sx={{
                                    fontWeight: value === 0 ? 900 : "bold",
                                    color: "#000",
                                    borderBottom: value === 0
                                        ? "3px solid #ff0033"
                                        : "3px solid transparent",
                                    pb: 0.5,
                                }}
                            />
                        )}

                        {/* دسته‌بندی‌ها: index + 1 */}
                        {fetchedCategories.map((category, index) => {
                            const tabIndex = index + 1;
                            const isActive = value === tabIndex;

                            return (
                                <Tab
                                    value={tabIndex}
                                    key={category.id}
                                    label={category.title}
                                    sx={{
                                        fontWeight: isActive ? 900 : "bold",
                                        color: "#000",
                                        borderBottom: isActive
                                            ? "3px solid #ff0033"
                                            : "3px solid transparent",
                                        pb: 0.5,
                                    }}
                                />
                            );
                        })}
                    </Tabs>

                </AppBar>

                {renderMarketHeader(marketInfo)}

                {renderMarketDescription(marketInfo)}
                <Box
                    sx={{
                        m: 1.5,
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.75,
                        alignItems: "center",
                    }}
                >


                    {this.props.tableId && this.state.tableInfo && (
                        <Tooltip title="اطلاعات میز" arrow>
                            <Chip
                                icon={
                                    <TableBarOutlinedIcon
                                        sx={{
                                            fontSize: 18,
                                            color: "#444",
                                        }}
                                    />
                                }
                                label={` ${this.state.tableInfo.floor_name} |  ${this.state.tableInfo.table_name}`}
                                sx={{
                                    height: 30,
                                    borderRadius: "8px",
                                    bgcolor: "rgba(255,255,255,0.95)",
                                    border: "2px solid rgba(137,137,137,1)",
                                    "&:hover": {bgcolor: "#fff"},
                                    "& .MuiChip-label": {
                                        fontWeight: 700,
                                        fontSize: 13,
                                        px: 1.2,
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                    "& .MuiChip-icon": {
                                        mr: 0.3,
                                        fontSize: 18,
                                    },
                                }}
                            />
                        </Tooltip>
                    )}

                    {(this.props.tableId == null || this.props.tableId === "") && (
                        <>
                            {marketInfo?.tell && (
                                <Chip
                                    icon={
                                        <PhoneOutlinedIcon
                                            sx={{ fontSize: 18 }}
                                        />
                                    }
                                    label={marketInfo.tell}
                                    clickable
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.location.assign(
                                            "tel:" + marketInfo.tell
                                        );
                                    }}
                                    sx={{
                                        height: 30,
                                        borderRadius: "8px",
                                        bgcolor: "rgba(255,255,255,0.95)",
                                        border:
                                            "2px solid rgba(137,137,137,1)",
                                        "&:hover": { bgcolor: "#fff" },
                                        "& .MuiChip-label": {
                                            fontWeight: 700,
                                            fontSize: 13,
                                            px: 1.2,
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                        "& .MuiChip-icon": {
                                            fontSize: 18,
                                            mr: 0.3,
                                            color: "#444",
                                        },
                                    }}
                                />
                            )}

                            {marketInfo?.whatsapp && (
                                <Tooltip title="WhatsApp" arrow>
                                    <Chip
                                        icon={
                                            <WhatsAppOutlinedIcon
                                                sx={{
                                                    fontSize: 18,
                                                    color: "#25D366",
                                                }}
                                            />
                                        }
                                        label={marketInfo.whatsapp}
                                        clickable
                                        component="a"
                                        href={`https://wa.me/${marketInfo.whatsapp}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        sx={{
                                            height: 30,
                                            borderRadius: "8px",
                                            bgcolor: "rgba(255,255,255,0.95)",
                                            border:
                                                "2px solid rgba(137,137,137,1)",
                                            "&:hover": {
                                                bgcolor: "#ffffff",
                                            },
                                            "& .MuiChip-label": {
                                                fontWeight: 700,
                                                fontSize: 13,
                                                px: 1.2,
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                            "& .MuiChip-icon": {
                                                mr: 0.3,
                                                fontSize: 18,
                                            },
                                        }}
                                    />
                                </Tooltip>
                            )}

                            {
                                shipping !== null && shipping !== undefined && (
                                    <Chip
                                        icon={<LocalShippingOutlinedIcon sx={{ fontSize: 18 }} />}
                                        label={
                                            "هزینه ارسال: پس‌کرایه"
                                        }
                                        sx={{
                                            height: 30,
                                            borderRadius: "8px",
                                            bgcolor: "rgba(255,255,255,0.95)",
                                            border: "2px solid rgba(137,137,137,1)",
                                            "& .MuiChip-label": {
                                                fontWeight: 700,
                                                fontSize: 13,
                                                px: 1.2,
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                            "& .MuiChip-icon": {
                                                fontSize: 18,
                                                mr: 0.3,
                                                color: "#555",
                                            },
                                        }}
                                    />
                                )
                            }

                            {categoryTitle && (
                                <Chip
                                    icon={
                                        <CategoryOutlinedIcon
                                            sx={{ fontSize: 18 }}
                                        />
                                    }
                                    label={categoryTitle}
                                    sx={{
                                        height: 30,
                                        borderRadius: "8px",
                                        bgcolor: "rgba(255,255,255,0.95)",
                                        border:
                                            "2px solid rgba(137,137,137,1)",
                                        "& .MuiChip-label": {
                                            fontWeight: 700,
                                            fontSize: 13,
                                            px: 1.2,
                                            display: "flex",
                                            alignItems: "center",
                                        },
                                        "& .MuiChip-icon": {
                                            fontSize: 18,
                                            mr: 0.3,
                                            color: "#555",
                                        },
                                    }}
                                />
                            )}

                            {insta && (
                                <Tooltip title={`${insta}`} arrow>
                                    <Chip
                                        icon={
                                            <InstagramOutlinedIcon
                                                sx={{
                                                    fontSize: 18,
                                                    color: "#E1306C",
                                                }}
                                            />
                                        }
                                        label={`${insta}`}
                                        clickable
                                        component="a"
                                        href={`https://instagram.com/${insta}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        sx={{
                                            height: 30,
                                            borderRadius: "8px",
                                            bgcolor: "rgba(255,255,255,0.95)",
                                            border:
                                                "2px solid rgba(137,137,137,1)",
                                            "&:hover": { bgcolor: "#fff" },
                                            "& .MuiChip-label": {
                                                fontWeight: 700,
                                                fontSize: 13,
                                                px: 1.2,
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                            "& .MuiChip-icon": {
                                                mr: 0.3,
                                                fontSize: 18,
                                            },
                                        }}
                                    />
                                </Tooltip>
                            )}

                            {bale && (
                                <Tooltip title={`${bale}`} arrow>
                                    <Chip
                                        icon={
                                            <BaleIcon
                                                sx={{
                                                    fontSize: 18,
                                                    color: "#2F80ED",
                                                }}
                                            />
                                        }
                                        label={`${bale}`}
                                        clickable
                                        component="a"
                                        href={`https://ble.ir/${bale}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        sx={{
                                            height: 30,
                                            borderRadius: "8px",
                                            bgcolor: "rgba(255,255,255,0.95)",
                                            border:
                                                "2px solid rgba(137,137,137,1)",
                                            "&:hover": { bgcolor: "#fff" },
                                            "& .MuiChip-label": {
                                                fontWeight: 700,
                                                fontSize: 13,
                                                px: 1.2,
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                            "& .MuiChip-icon": {
                                                mr: 0.3,
                                                fontSize: 18,
                                            },
                                        }}
                                    />
                                </Tooltip>
                            )}

                            {rubika && (
                                <Tooltip title={`${rubika}`} arrow>
                                    <Chip
                                        icon={
                                            <RubikaIcon
                                                sx={{
                                                    fontSize: 18,
                                                    color: "#24A1DE",
                                                }}
                                            />
                                        }
                                        label={`${rubika}`}
                                        clickable
                                        component="a"
                                        href={`https://rubika.ir/${rubika}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        sx={{
                                            height: 30,
                                            borderRadius: "8px",
                                            bgcolor: "rgba(255,255,255,0.95)",
                                            border:
                                                "2px solid rgba(137,137,137,1)",
                                            "&:hover": { bgcolor: "#fff" },
                                            "& .MuiChip-label": {
                                                fontWeight: 700,
                                                fontSize: 13,
                                                px: 1.2,
                                                display: "flex",
                                                alignItems: "center",
                                            },
                                            "& .MuiChip-icon": {
                                                mr: 0.3,
                                                fontSize: 18,
                                            },
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </>
                    )}
                </Box>

                {/* Panel 0: همه محصولات (Conditionally Rendered) */}
                {!hasInitialCategories && (
                    <TabPanel value={value} index={0}>
                        <ProductComponent
                            market_id={this.props.id}
                            category_id={-1}
                            market_floor_ids={this.props.initialFloors}
                            table_id={this.props.tableId}

                        />
                    </TabPanel>
                )}

                {/* Panelهای دسته‌بندی‌ها */}
                {fetchedCategories.map((category, index) => (
                    <TabPanel
                        key={category.id}
                        value={value}
                        index={index + 1}
                    >
                        <ProductComponent
                            market_id={this.props.id}
                            category_id={category.id}
                            market_floor_ids={this.props.initialFloors}
                            table_id={this.props.tableId}
                        />
                    </TabPanel>
                ))}

                {!this.props.tableId && <BottomMenu/>}

                <Box
                    component="footer"
                    sx={{
                        backgroundColor: '#1e1e1e',
                        color: '#f1f1f1',
                        px: 3,
                        py: 4,
                        mt: 6,
                        fontSize: 14,
                        pb: "70px",
                        textAlign: 'center'
                    }}
                >
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} sm={4}>
                            <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                درباره همه کارا
                            </Typography>
                            <Typography variant="body2" sx={{mb: 1}}>
                                سامانه فروشگاهی <strong>همه کارا</strong> راهکاری نوین برای مدیریت فروشگاه‌های
                                آنلاین و
                                آفلاین است. با امکانات ثبت سفارش، باشگاه مشتریان، گزارش‌ گیری مالی و پشتیبانی.
                            </Typography>
                            <a
                                href="https://intro.hamekara.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{color: '#4fc3f7', textDecoration: 'none', fontWeight: 'bold'}}
                            >
                                معرفی کامل همه کارا
                            </a>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                تماس با ما
                            </Typography>
                            <Typography variant="body2" sx={{mb: 0.5}}>📞 0383-228-5853</Typography>
                            <Typography variant="body2" sx={{mb: 0.5}}>📧 thetoptraders@gmail.com</Typography>
                            <Typography variant="body2"> 📍 ایران - شهرکرد - ساختمان علم و فناوری پردیس - طبقه
                                سوم -
                                واحد 305</Typography>
                        </Grid>

                        <Grid item xs={12} sm={4}
                              sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                            <div className="trust-badge">
                                <a
                                    referrerPolicy="origin"
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                >
                                    <img
                                        referrerPolicy="origin"
                                        src="https://trustseal.enamad.ir/logo.aspx?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                        alt=""
                                        style={{cursor: "pointer"}}
                                        code="W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                    />
                                </a>
                            </div>
                        </Grid>
                    </Grid>

                    <Divider sx={{my: 3, bgcolor: '#555'}}/>

                    <Typography variant="caption" sx={{color: '#aaa'}}>
                        © {new Date().getFullYear()} Hamekara.com - کلیه حقوق محفوظ است
                    </Typography>
                </Box>
            </div>
        );
    }
}

// Add this at the very end of the file
ProductCollectionComponent.defaultProps = {
    initialCategories: [],
    initialCategory: undefined,
};
